import { createClient } from '@supabase/supabase-js'

const supabaseUrl  ="https://vjgxtkapcrzyrzwxgmyn.supabase.co"
const supabaseKey  ="eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZqZ3h0a2FwY3J6eXJ6d3hnbXluIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI3NjI0NTksImV4cCI6MjA4ODMzODQ1OX0.d1DID1pRwgqb-pVeMf1pPYakUN3ut4PlKFkeS1vybPk"

export const supabase = createClient(supabaseUrl, supabaseKey)
